import { render, staticRenderFns } from "./DeliveryZonesManager.vue?vue&type=template&id=2eb91861&scoped=true&"
import script from "./DeliveryZonesManager.vue?vue&type=script&lang=ts&"
export * from "./DeliveryZonesManager.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryZonesManager.vue?vue&type=style&index=0&id=2eb91861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb91861",
  null
  
)

export default component.exports